/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedBlurbDesignYourOwn_viewer = {
    readonly isDyoEnabled: boolean | null;
    readonly " $refType": "PdpSharedBlurbDesignYourOwn_viewer";
};
export type PdpSharedBlurbDesignYourOwn_viewer$data = PdpSharedBlurbDesignYourOwn_viewer;
export type PdpSharedBlurbDesignYourOwn_viewer$key = {
    readonly " $data"?: PdpSharedBlurbDesignYourOwn_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedBlurbDesignYourOwn_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedBlurbDesignYourOwn_viewer",
  "selections": [
    {
      "alias": "isDyoEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "designYourOwn"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"designYourOwn\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = 'ad7a7b56b89919263fd627d7630e9641';
export default node;
